const nuclearNoCacheHeaders = {
  pragma: 'no-cache',
  'cache-control': 'max-age=0, no-cache, no-store',
  Vary: '*'
};

export { nuclearNoCacheHeaders };
